export default{
    user: null,
    empresa: null,
    isLogged: false,

}